import Home from '../Pages/Home';

export default {
    'Home': <Home />
}